import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import zenM2 from '../../images/zenmentum3.png';
import bb from '../../images/bbounty2.png';
import nw from '../../images/N-W.png';
// import translator from '../../images/translator.png';
import geoExp from '../../images/GeoExp.png';

import ts from '../../images/tagsvg/ts.svg';
import sass from '../../images/tagsvg/sass.svg';
import mongo from '../../images/tagsvg/mongo.svg';
import express from '../../images/tagsvg/express.svg';
import reactTag from '../../images/tagsvg/react.svg';
import reduxTag from '../../images/tagsvg/redux.svg';
import firebase from '../../images/tagsvg/firebase.svg';
import tailwind from '../../images/tagsvg/tailwind.svg';
import jest from '../../images/tagsvg/jestTag.svg';
import cypress from '../../images/tagsvg/cypressTag.svg';
import particle from '../../images/tagsvg/particle.svg';
import next from '../../images/tagsvg/next.svg';
import axiosTag from '../../images/tagsvg/axios.svg';


import {
  bandBountyDesc,
  zenmentumDesc,
  geoExpDesc,
  noteWarr,
} from './projectDescription';
import MobileContent from './MobileContent';

gsap.registerPlugin(ScrollTrigger);

const Slider = () => {
  const headlineRef = useRef([]);

  useEffect(() => {
    let headlineElArr = headlineRef.current;

    // Ensure GSAP and ScrollTrigger are ready
    // if (typeof window !== 'undefined') {
    const details = gsap.utils.toArray('.desktopPhoto:not(:first-child)');
    // const detailsWithFirst = gsap.utils.toArray('.desktopPhoto');

    const photos = gsap.utils.toArray('.desktopPhoto:not(:first-child)');
    gsap.set(photos, { yPercent: 101 });

    //Set up mm here

    let mm = gsap.matchMedia();

    mm.add('(min-width: 600px)', () => {
      ScrollTrigger.create({
        trigger: '.gallery',
        start: 'top top',
        end: 'bottom bottom',
        pin: '.right',
      });

      details.forEach((detail, index) => {
        let tl = gsap.timeline();
        tl.to(photos[index], { yPercent: 0 });
        // tl.to('.gallery', {
        //   background: colorGradients[index],
        // });

        let headline = headlineElArr[index + 1];
        ScrollTrigger.create({
          trigger: headline,
          start: 'top 80%',
          end: 'top 40%',
          animation: tl,
          scrub: true,
        });
      });

      return () => {};
    });
  }, []);

  return (
    <div>
      <div className="gallery">
        <div className="left">
          <div className="desktopContent">
            <div className="desktopContentSection">
              <div className="block">
                <h1
                  className="desktop-title"
                  ref={(el) => headlineRef.current.push(el)}
                >
                  Note-Warriors
                </h1>
                <div>
                  <ul className="desktop-list">
                    <li className="desktop-tag">
                      <img
                        src={ts}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Typescript
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={tailwind}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Tailwind
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={next}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Next
                    </li>
                    {/* <li className="desktop-tag">
                      <img
                        src={express}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      ExpressJs
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={reactTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      React
                    </li> */}
                  </ul>
                </div>
                <p className="desktop-p">{noteWarr}</p>
                <div className="button-section">
                  <a
                    href="https://note-warriors-danboyce92.vercel.app/"
                    className="live-button"
                  >
                    Live Project
                  </a>
                  <a
                    href="https://github.com/danboyce92/note-warriors-next"
                    className="repo-button"
                  >
                    Github Repo
                  </a>
                </div>
              </div>
            </div>
            <div className="desktopContentSection">
              <div className="block">
                <h1
                  className="desktop-title"
                  ref={(el) => headlineRef.current.push(el)}
                >
                  ZenMentum
                </h1>
                <div>
                  <ul className="desktop-list">
                    <li className="desktop-tag">
                      <img
                        src={ts}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Typescript
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={sass}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Sass
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={mongo}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      MongoDb
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={express}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      ExpressJs
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={reactTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      React
                    </li>
                  </ul>
                </div>
                <p className="desktop-p">{zenmentumDesc}</p>
                <div className="button-section">
                  <a
                    href="https://zenmentum-front.vercel.app/"
                    className="live-button"
                  >
                    Live Project
                  </a>
                  <a
                    href="https://github.com/danboyce92/Productivity-Tracker-App"
                    className="repo-button"
                  >
                    Github Repo
                  </a>
                </div>
              </div>
            </div>
            <div className="desktopContentSection">
              <div className="block">
                <h1
                  className="desktop-title"
                  ref={(el) => headlineRef.current.push(el)}
                >
                  Band Bounty
                </h1>
                <div>
                  <ul className="desktop-list">
                    <li className="desktop-tag">
                      <img
                        src={reactTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      React
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={reduxTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Redux
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={firebase}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Firebase
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={tailwind}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Tailwind
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={particle}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      ParticleJs
                    </li>
                  </ul>
                </div>

                <p className="desktop-p">{bandBountyDesc}</p>
                <div className="button-section">
                  <a
                    href="https://band-bounty.vercel.app/"
                    className="live-button triple"
                  >
                    Live Project
                  </a>
                  <a
                    href="https://github.com/danboyce92/Band-Bounty-Mockup"
                    className="repo-button triple"
                  >
                    Github Repo
                  </a>
                  <a
                    href="https://github.com/danboyce92/BandBountyRebuild"
                    className="repo-button triple"
                  >
                    Smart Contract
                  </a>
                </div>
              </div>
            </div>
            <div className="desktopContentSection">
              <div className="block">
                <h1
                  className="desktop-title"
                  ref={(el) => headlineRef.current.push(el)}
                >
                  Geo-Explorer
                </h1>
                <div>
                  <ul className="desktop-list">
                    <li className="desktop-tag">
                      <img
                        src={reactTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      React
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={reduxTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Redux-Toolkit
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={jest}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Jest
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={cypress}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Cypress
                    </li>
                    <li className="desktop-tag">
                      <img
                        src={axiosTag}
                        className="desktop-img-tag"
                        alt="logo-tag"
                      />
                      Axios
                    </li>
                  </ul>
                </div>

                <p className="desktop-p">{geoExpDesc}</p>
                <div className="button-section last">
                  <a
                    href="https://geo-explorer-henna.vercel.app/"
                    className="live-button"
                  >
                    Live Project
                  </a>
                  <a
                    href="https://github.com/danboyce92/GeoExplorer"
                    className="repo-button"
                  >
                    Github Repo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right">
          <MobileContent />

          <div className="desktopPhotos">
            <div id="red" className="desktopPhoto">
              <img id="red-img" src={nw} alt="testimage" />
            </div>
            <div className="desktopPhoto">
              <img id="green" src={zenM2} alt="testimage" />
            </div>
            <div className="desktopPhoto">
              <img id="pink" src={bb} alt="testImage2" />
            </div>
            <div id="blue" className="desktopPhoto">
              <img id="blue" src={geoExp} alt="geoExp" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
